import { TRIGGER_METHOD } from '@atlaskit/editor-common/analytics';
import { bindKeymapWithCommand, find as findKeymap } from '@atlaskit/editor-common/keymaps';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { activateWithAnalytics } from './commands-with-analytics';
var activateFindReplace = function activateFindReplace(editorAnalyticsAPI) {
  return function (state, dispatch) {
    activateWithAnalytics(editorAnalyticsAPI)({
      triggerMethod: TRIGGER_METHOD.SHORTCUT
    })(state, dispatch);
    return true;
  };
};
var keymapPlugin = function keymapPlugin(editorAnalyticsAPI) {
  var list = {};
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  bindKeymapWithCommand(findKeymap.common, activateFindReplace(editorAnalyticsAPI), list);
  return keymap(list);
};
export default keymapPlugin;